<div class="no-ie danger-notify" *ngIf="isDanger">
  <div class="no-ie-box">
    <div class="d-flex justify-content-center">
      <div style="margin-top: -60px;">
        <div style=" width: 100%">
          <img src="{{'./assets/images/message/danger.png' | absUrl}}" style="display: block;margin: 0 auto 60px;" />
        </div>
        <span>您正在访问仿冒网站，您的用户数据可能已泄漏！</span><br />
        <span>请使用{{ siteTitle }}官方域名访问：{{officialSite}}</span>
      </div>
    </div>
  </div>
</div>


<div class="navbar" *ngIf="!hideTop"></div>

<router-outlet></router-outlet>

<!-- <app-recharge-box></app-recharge-box> -->

<app-sticky-block *ngIf="!hideSticky" [showStickyChat]="showStickyChat"></app-sticky-block>

<app-sticky-chat *ngIf="!hideStickyChat && !isFullScreen"></app-sticky-chat>

<div *ngIf="ifGuide" class="guide-cover" (click)="closeGuide()"></div>
<video src="./assets/javascript/empty2.mp4" autoplay="true" preload="auto" muted
  style="width: 1px;height:1px;position: absolute;bottom:0;left:0;" #playVideo playsinline="true"></video>